export default __webpack_public_path__ + "static/media/Techshop2.d2dc2da9.png";